<app-heading
  title="Configurações"
  subtitle="Gerencie as configurações do sistema."
  size="small"
/>
<content-wrapper>
  <div class="settings-grid">
    @for (item of settingsItems; track item.id) {
      <p-card class="settings-card">
        <div class="settings-card-content">
          <div class="settings-card-icon">
            <i [class]="'bi ' + item.icon"></i>
          </div>
          <div class="settings-card-body">
            <h5 class="settings-card-title">{{ item.label }}</h5>
            <p class="settings-card-description">{{ item.description }}</p>
            <p-button
              [label]="'Configurar ' + item.label"
              icon="pi pi-arrow-right"
              iconPos="right"
              severity="secondary"
              (onClick)="navigateTo(item)"
            />
          </div>
        </div>
      </p-card>
    }
  </div>
</content-wrapper>
